export const getPostRating = (state, postId) =>
  state.postRatings[postId]?.rating;

export const getPostRatingCount = (state, postId) =>
  state.postRatings[postId]?.ratingCount;
